"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _EndAdornmentWrapper = _interopRequireDefault(require("./EndAdornmentWrapper"));
var _TextAdornment = _interopRequireDefault(require("../TextAdornment"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var getInputElement = function getInputElement(ref, name) {
  var current = ref.current;
  return current && current.ownerDocument ? current.ownerDocument.getElementsByName(name)[0] : null;
};
var EndAdornment = function EndAdornment(_ref) {
  var name = _ref.name,
    adornment = _ref.adornment,
    _ref$inputValue = _ref.inputValue,
    inputValue = _ref$inputValue === void 0 ? '' : _ref$inputValue,
    withCounter = _ref.withCounter,
    maxLength = _ref.maxLength,
    multiline = _ref.multiline,
    disabled = _ref.disabled;
  var isTextEndAdornment = adornment && (typeof adornment === 'string' || Boolean(adornment.defaultMessage));
  var isCharCounter = withCounter && maxLength;
  var _useState = (0, _react.useState)(inputValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var adornmentRef = (0, _react.useRef)(null);
  var inputElement = getInputElement(adornmentRef, name);

  /*
   * Adding these event listeners in favor of useWatch because we need to be able to
   * get the input value and avoid too much unnecessary rerenders
   */
  (0, _react.useEffect)(function () {
    if (inputElement) {
      inputElement.addEventListener('input', function (e) {
        setValue(e.target.value);
      });
    }
  }, [inputElement], function () {
    return inputElement.removeEventListener('input');
  });
  if (isTextEndAdornment || isCharCounter) {
    var message = isCharCounter ? "".concat(value.length, "/").concat(maxLength) : adornment;
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: adornmentRef
    }, /*#__PURE__*/_react["default"].createElement(_TextAdornment["default"], {
      ariaLabelledby: name,
      disabled: disabled,
      multiline: multiline,
      message: message
    }));
  }
  if (adornment) {
    return /*#__PURE__*/_react["default"].createElement(_EndAdornmentWrapper["default"], {
      disabled: disabled,
      ref: adornmentRef
    }, adornment);
  }
  return null;
};
EndAdornment.propTypes = process.env.NODE_ENV !== "production" ? {
  adornment: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string, _propTypes["default"].bool]),
  name: _propTypes["default"].string,
  inputValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  withCounter: _propTypes["default"].bool,
  maxLength: _propTypes["default"].number,
  multiline: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool
} : {};
var _default = exports["default"] = EndAdornment;